import React from 'react';

export default function InfoRow({ rowName, rowValue }) {
    return <div className='sectionRow'>
        <p>{rowName}</p>
        <p>{rowValue.toString()}</p>
    </div>
}
